export default {
    root: function (_a) {
        var props = _a.props, context = _a.context, parent = _a.parent;
        return ({
            class: [
                'tw-m-0 tw-outline-0 focus:tw-outline-0 tw-outline-transparent',
                'tw-block tw-w-full tw-rounded-md tw-border-0 tw-text-gray-900 tw-ring-1 tw-ring-inset tw-ring-gray-300 placeholder:tw-text-gray-400 sm:tw-leading-6',
                'dark:tw-bg-zinc-500 dark:tw-text-gray-100 dark:tw-ring-0 dark:autofill:tw-bg-zinc-600',
                {
                    'focus:tw-ring-2 focus:tw-outline-none dark:focus:tw-ring-2 focus:tw-ring-inset focus:tw-ring-primary-300': !context.disabled,
                    'tw-opacity-60 tw-select-none tw-pointer-events-none tw-cursor-default tw-bg-gray-100 tw-ring-gray-200': context.disabled,
                },
                {
                    'tw-text-lg tw-px-4 tw-py-4': props.size == 'large',
                    'tw-text-xs tw-px-2 tw-py-2': props.size == 'small',
                    'tw-px-2 tw-py-1 tw-text-lg sm:tw-text-md ': props.size == null,
                },
                { 'first:tw-rounded-l-md tw-rounded-none last:tw-rounded-r-md': parent.instance.$name == 'InputGroup' },
            ],
        });
    },
};
